module.exports = __webpack_public_path__ + "media/images/product_large_images/stand-6d57167131679aa8ecb7110fdab121e8.png";